import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { useMemo } from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router';
import { tailwindConfig } from 'tailwind-config';

import { ROUTE_PATHS } from 'shared/consts/routes';
import { useTypedSelector } from 'store';

import { BalanceBotIcon } from 'assets/icons';

const MexcDistributorSideBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isSidebarOpened = useTypedSelector(store => store.ui.isSidebarOpened);
  const isActive = useMemo(
    () => Boolean(matchPath(`${ROUTE_PATHS.mexcDistributor}/*`, pathname)),
    [pathname],
  );

  return (
    <div
      className={cn('mm-sidebar__menu__item', { _active: isActive })}
      onClick={() => navigate(ROUTE_PATHS.mexcDistributor)}
    >
      <div className="mm-sidebar__menu__item__left">
        <div className="mm-sidebar__menu__item__icon">
          <BalanceBotIcon color={isActive ? tailwindConfig.theme.colors.primary : undefined} />
        </div>
        <AnimatePresence>
          {isSidebarOpened && (
            <motion.span
              exit={{ opacity: 0, width: 0 }}
              transition={{ duration: isSidebarOpened ? 0.25 : 0 }}
              className="mm-sidebar__menu__item__text"
            >
              MEXC distributor
            </motion.span>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export { MexcDistributorSideBar };
